import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { openNotification } from "src/components/helpers/notification"
import ax from "src/store/config"

const initialState = {
  PaymentRemindersList: null,
  PaymentRemindersListLoading: false,
  mnemo: null,
}

export const getPaymentReminders = createAsyncThunk(
  'paymentReminders/getPaymentReminders', 
  async(payload, { rejectWithValue }) => {
    try{
      const { data } = await ax.get("api/admin/directory/paymentReminders", {
        params: {
          ...payload?.value,
        }
      })
      return data
    } catch(error) {
      openNotification('error', 'Ошибка', `Ошибка ${error.response?.data?.errorMessages?.[0]?.errorCode}. ${error.response?.data?.errorMessages?.[0]?.errorMessage}`)
      return rejectWithValue(error.response?.data)
    }
  }
)

const PaymentRemindersSlice = createSlice({
  name: "PaymentReminders",
  initialState,
  reducers: {
    setPaymentRemindersListLoading: (state, action) => {
      state.PaymentRemindersListLoading = action.payload
    },
    setMnemo: (state, action) => {
      state.mnemo = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getPaymentReminders.pending, (state) => {
      state.PaymentRemindersListLoading = true
    })
    builder.addCase(getPaymentReminders.fulfilled, (state, action) => {
      state.PaymentRemindersListLoading = false
      state.PaymentRemindersList = action.payload
    })
    builder.addCase(getPaymentReminders.rejected, (state) => {
      state.PaymentRemindersListLoading = false
    })
  }
})

export const { setPaymentRemindersListLoading, setMnemo } = PaymentRemindersSlice.actions
export default PaymentRemindersSlice.reducer